import { gql } from '@apollo/client';

const GET_PRODUCT_CURRICULUM = gql`
  query getProductCurriculum($where: ProductCurriculumWhereInput!) {
    productCurriculum(where: $where) {
      name
      gradeLevel
    }
  }
`;

export default GET_PRODUCT_CURRICULUM;
